export const ROUTE_LANDING_PAGES = '/landing-pages';
export const ROUTE_LANDING_PAGES_CONGRATS = `${ROUTE_LANDING_PAGES}/:funnelCode/congrats`;
export const ROUTE_LANDING_PAGES_CLICKFUNNELS = `${ROUTE_LANDING_PAGES}/:funnelCode`;
export const ROUTE_LANDING_PAGES_CLICKFUNNELS_UPSELL = `${ROUTE_LANDING_PAGES}/:funnelCode/upsell`;
